import { render, staticRenderFns } from "./flightcargo.vue?vue&type=template&id=3e23faf0&scoped=true&"
import script from "./flightcargo.vue?vue&type=script&lang=js&"
export * from "./flightcargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e23faf0",
  null
  
)

export default component.exports